<template>
  <div class="shortAnswer">
    <div class="top">
      题目：
      <el-input
        v-model="smallTopic.topicName"
        placeholder="请输入题目"
        style="width: 70%"
        type="textarea"
        autosize
      ></el-input>
    </div>
  </div>
</template>

<script>
export default {
  name: 'shortAnswer',
  components: {},
  props: {
    smallTopic: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  watch: {},
  computed: {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.shortAnswer {
  .top {
    margin: 10px 0;
  }
}
</style>